import { Divider } from "@portal/BaseComponents/Divider/AntDivider";
import { FilterDropDownButton } from "@portal/BaseComponents/Filters/FilterDropdown/FilterDropDownButton";
import { FilterStrip } from "@portal/BaseComponents/Filters/Strip/FilterStrip";
import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { MenuClick } from "@portal/BaseComponents/Menu/type";
import { documentFiltersAtom } from "@portal/store/Filters/documents/document-filter";
import { defaultDocumentKeys } from "@portal/store/Filters/documents/predicate";
import { DefaultDocumentKeys } from "@portal/store/Filters/documents/type";
import produce from "immer";
import { useAtom } from "jotai";
import { useMemo } from "react";
import { AddedOnFilter } from "./AddedOn/AddedOnFilter";
import { DocumentTypesFilter } from "./DocumentTypes/DocumentType";
import { DocumentView } from "./DoumentView/DocumentView";

function DocumentFilter() {
  const [documentFilters, setDocumentFilters] = useAtom(documentFiltersAtom);

  function getSelectedFilterKeys() {
    return [...documentFilters.activeFilterKeys];
  }

  function handleClick(e: MenuClick["0"]) {
    if (defaultDocumentKeys.includes(e.key as DefaultDocumentKeys)) {
      setDocumentFilters((prev) => {
        return produce(prev, (draft) => {
          draft.activeFilterKeys.push(e.key as DefaultDocumentKeys);
        });
      });
      return;
    }
  }

  const selectedValues = useMemo(getSelectedFilterKeys, [
    documentFilters.activeFilterKeys,
  ]);

  return (
    <FilterStrip width="222px">
      <DocumentView />
      <Flex align="start">
        <Divider type="vertical" style={{ margin: 0, height: "32px" }} />
        <Flex style={{ width: "100%" }} wrap>
          <DocumentTypesFilter />
          <AddedOnFilter />
          <FilterDropDownButton
            handleClick={handleClick}
            items={documentFilters.filterGroup}
            selectedValues={selectedValues}
            key={selectedValues.length}
          />
        </Flex>
      </Flex>
    </FilterStrip>
  );
}

export { DocumentFilter };
